import styles from "./Orders.module.css"
import { useEffect, useState } from 'react';
import OrderCard from "../../../../../components/Cards/OrderCard/OrderCard";
import { useTranslation } from "react-i18next";
import { PastOrder } from "../../../../../types/order.types";
import { useOrderContext } from "../../../../../context/OrderContext";
import { useUserContext } from "../../../../../context/UserContext";
import { getPastOrders } from "../../../../../services/orderService";
import { log } from "../../../../../utils/logger";


/**
 * Orded page
 * Contains past and canceled orders, handles adding them to cart
 * @returns TSX.Element
*/
const OrderPage = () => {
    const { t } = useTranslation(); // Translation
    const [selectedOrderPage, setSelectedOrderPage] = useState("done")
    const { orderData } = useOrderContext();
    const { loggedIn, userData } = useUserContext(); // User Context
    const [orders, setOrders] = useState<PastOrder[] | undefined>(undefined);
    const [filteredOrders, setFilteredOrders] = useState<PastOrder[]>([]); // Orders based on order type (past/canceled)
    // Get past orders
    useEffect(() => {
        if (!loggedIn) return;
        const primarySubscriber = userData?.subscribers?.[0]?.subscriber_id ?? null;
        const subscriberId = orderData.recipient ?? primarySubscriber;
        if (!subscriberId) return;

        getPastOrders({ subscriberId })
            .then((data) => {
                setOrders(data);
                //log("Past orders fetched:", data);
            })
            .catch((error) => {
                //log("Failed to load past orders:", error);
                setOrders([]);
                setFilteredOrders([]);
            });
    }, [loggedIn, userData, orderData.recipient]);

/* ordered jako flag ver
    useEffect(()=>{
        if(!orders) return;
        if(selectedOrderPage === "done"){
            const newOrders = orders.filter(order=>order.ordered === true)
            setFilteredOrders(newOrders);
        }else{
            const newOrders = orders.filter(order=>order.ordered === false)
            setFilteredOrders(newOrders);
        }
    }, [selectedOrderPage, orders])
    */
    useEffect(() => {
        if (!orders) return;
        const isCanceled = (order: PastOrder) => {
            const state = (order.order?.state ?? order.state ?? "").toLowerCase();
            return state.includes("storn") || state.includes("cancel");
        };

        if (selectedOrderPage === "done") {
            setFilteredOrders(orders.filter((order) => !isCanceled(order)));
        } else {
            setFilteredOrders(orders.filter((order) => isCanceled(order)));
        }
    }, [selectedOrderPage, orders])


    return(
        <>
            <div className={styles.OrderPageContent}>
                <p className={styles.OrderPageContentTitle}>{t("account.titles.orders")}</p>
                <div className={styles.OrderPageContentCenter}>
                    <div className={styles.OrderSection}>
                        <div className={styles.OrderSectionHeader}>
                            <button className={`${styles.ContentSwitch} ${selectedOrderPage === "done" && styles.ContentSwitchActive}`} onClick={()=>setSelectedOrderPage("done")}>
                                <p>{t("account.orders.past")}</p>
                            </button>
                            {/*
                            <button className={`${styles.ContentSwitch} ${selectedOrderPage === "canceled" && styles.ContentSwitchActive}`} onClick={()=>setSelectedOrderPage("canceled")}>
                                <p>{t("account.orders.canceled")}</p>
                            </button>
                            */}
                        </div>
                        <div className={styles.OrderWrap}>
                            {filteredOrders.map((order, index)=>(
                                <OrderCard
                                order={order}
                                key={index}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderPage;
